<template>
   <b-modal
      title="Invite User"
      @hidden="hidden"
      id="modal-invite-user"
      size="lg"
      centered
      ok-variant="primary"
      cancel-variant="light"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
   >
      <InviteUser @submit-action="submitAction" />
   </b-modal>
</template>

<script>
import InviteUser from '@/components/forms/InviteUser.vue';

export default {
   name: 'InviteUserModal',
   components: {InviteUser},

   methods: {
      show() {
         this.$bvModal.show('modal-invite-user');
      },
      hide() {
         this.$bvModal.hide('modal-invite-user');
      },
      hidden() {
         this.$emit('afterClose');
      },
      submitAction() {
         this.hide();
      },
   },
};
</script>

<style scoped lang="scss">
::v-deep .modal-footer {
   padding: 1rem 2rem !important;
}

.my-custom-ok-btn {
   padding: 5px 30px;
   font-size: 13px !important;
   background-color: #0978cd !important;
   border: 1px solid #0978cd;
   &:hover {
      background-color: #0978cd !important;
      border: 1px solid #0978cd;
   }
}
</style>
